import axios from 'axios'
import store from '@/store'
export default () => {
  return axios.create({
    // baseURL: `http://localhost:7080/api/`,
    baseURL: `https://app.complementservices.com/api/`,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}